fx.ns("desktop.calendar", class CalendarEditor extends fx.Component {

	constructor(data) {
		super(data);
	}

	contextMenu(e) {
		return [];
	}

	create() {
		super.create();

		this.mediaTabs = new desktop.calendar.MediaTabs(this.data);
		this.addChild(this.mediaTabs, { top: 0, left: 0, width: 340, height: "100%" });

		this.board = new desktop.calendar.CalendarBoard(this.data, desktop.calendar.ComponentFactory);
		this.addChild(this.board, { top: 0, left: 340, width: "100%", height: "100%" });

		this.topBar = new desktop.common.actionbar.TopBar(this.data.creation);
		this.addChild(this.topBar, { top: 20, right: 25, width: 100 });

		this.actionBar = new desktop.common.actionbar.ActionBar(this.data);
		this.addChild(this.actionBar, { top: "center", right: 25, width: 70 });

		this.topNotifications = new desktop.common.TopNotifications(this.data);
		this.topNotifications.visibleAtStart = false;
		this.addChild(this.topNotifications, { top: 10, right: 25 });

		this.dragger = new desktop.common.behaviour.ComponentDragger(this.data, this);


        this.productLabel = new desktop.common.ProductLabel(this.data);
        
        this.addChild( this.productLabel, { top : 25, height : 50, left:340,width:"100%"} );
	}

	onDisplayUpdated() {
		if (this._optionSelectContainer)
			this._optionSelectContainer.viewport({ width: this.board.realWidth - this.topBar.realWidth - this.topBar.right(), height: 50, top: 10, left: this.board.left() });
	}

	onReady() {
		super.onReady();

		this.on("currentAreaChanged", this.onCurrentAreaChanged, this.board);
		this.on("currentElementChanged", this.onCurrentElementChanged, this.board);

		//this.on("photo-extracted", this._onPhotoExtractedFinished, fx.service("MediasUploader").photoExtractor);

		if (this.mediaTabs)
			this.mediaTabs.currentArea = this.board.currentArea;

		this.on("scrolled", this._onScroll, this.board);

		this.on("order", this._onOrder, this.topBar);
		this.on("exit", this._onExit, this.topBar);


		this.listenUpdates(this.data.creation, true);

		this._updateCreationLabel();

		// the creation is undeleted on the first modification, not on the opening of the editor
		this.data.undeleteOnFirstUpdate();

		this.data.history.start();

		this.delay(this._setWelcomeTips, 500);
	}

   
	show(callback) {
		super.show(callback);
        
		fx.set("mode", "edition");
	}

    _onScroll()
	{
		if (this.productLabel && this.board)
			this.productLabel.toggle(this.board.scrollTop <= 30 && this.data.zoom.value == 100);
	}


	_onOrder() {
		this.data.event("order");
	}

	_onExit() {
		this.data.event("exit-editor");
	}

	enable() {
		super.enable();
		this.board.enable();
	}

	disable() {
		super.disable();
		this.board.disable();
	}

	onCurrentAreaChanged(e) {
		if (this.mediaTabs)
			this.mediaTabs.currentArea = e.detail;
	}

	onCurrentElementChanged(e) {
		// nothing to do
	}

	onDataEvent(e) {
		switch (e.type) {
			case "switch-photoPanel":
				this.mediaTabs.tabs.selectTab(this.mediaTabs.photoPanel);
				break;

			case "currentAreaChanged":
				this.onCurrentAreaChanged(e);
				break;

		}
	}

	onChildUpdated(action) {
		if (action.model instanceof models.ProductCalendar)
			this.delay(this._updateCreationLabel, 250);
	}

	onDataUpdated(action) {
		if (action.model instanceof models.ProductCalendar)
			this.delay(this._updateCreationLabel, 250);
	}

	_updateCreationLabel() {
		if (!this._optionSelect) return;

		this._optionSelect.label = this.data.creation.format.name + ", " + this.data.creation.format.description;;
	}
	
     _setWelcomeTips()
    {
        fx.service("WelcomeTips", {model :this.data, editor : this});
         
        let notifications = [];

        //if (this.mediaTabs.photoPanel && this.mediaTabs.photoPanel.button)
        //    notifications.push( {trigger:"add-photo", forbidenComponentClass : "PopupPanel", component : this.mediaTabs.photoPanel.button, title :  fx.text("On Commence ?"), text :  fx.text("Ajoutez vos photos, puis déplacez-les sur vos pages"), start : true } );
        
        if (!this.data.creation.started)
            notifications.push( {trigger:"choose-layout", forbidenComponentClass : "PopupPanel", component : this.mediaTabs, title :  fx.text("On Commence ?"), text :  fx.text("Choisissez votre modèle<br>Puis ajouter vos photos"), start : true, always : true } );

        fx.service("WelcomeTips").notifications( notifications );    
    }

});